import { useEffect, useState } from 'react';

import { readCookie } from 'utils/Cookies';
import { Environment } from 'utils/Environment';

export interface IDetailedPromotion {
  readonly promotionName: string;
  readonly promoCode: string;
  readonly promotionDescription: string;
  readonly promotionLongDescription: string;
  readonly startDate: string;
  readonly endDate: string;
}

export const useProgramPromotion = (resellerId?: string) => {
  const api = Environment.current.genesisApiClient;
  const [programPromotion, setProgramPromotion] = useState<IDetailedPromotion | undefined>();
  const [isProgramPromoLoading, setIsProgramPromoLoading] = useState(false);

  useEffect(() => {
    const fdmpPromoCode = readCookie('program');
    const requestUrl = `/v1/resellers/${resellerId}/promotions/${fdmpPromoCode}`;

    if (!fdmpPromoCode || !resellerId) return;

    setIsProgramPromoLoading(true);

    api
      .get<IDetailedPromotion>(requestUrl)
      .then(response => {
        setProgramPromotion(response.data);
        setIsProgramPromoLoading(false);
      })
      .catch(() => {
        setIsProgramPromoLoading(false);
        console.error(`Error Fetching Program Promotion for ${resellerId}, code ${fdmpPromoCode}`);
      });
  }, [resellerId, api]);

  return { programPromotion, isProgramPromoLoading };
};
